var exports = {
  "s8": "PrimerLink__MEoINk",
  "lF": "ActionList__vBkytw",
  "lV": "ActionList_LinkItem__32PRqx",
  "re": "GitHubAvatar__ndb-WJ",
};

module.exports = exports;
